import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Container
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { formatPrice } from '@/utils';
import { usePlans } from '@/hooks/price';
import { IMAGE_TTL_HOURS, TRIAL_DAYS } from '@/config';

export function FaqAccordions() {
	const { t } = useTranslation();
	const { trialPlan, mainPlan } = usePlans();

	const bestPrice = formatPrice({
		amount: mainPlan?.baseAmount,
		currency: mainPlan?.currency
	});

	const trialPrice = formatPrice({
		amount: trialPlan?.baseAmount,
		currency: trialPlan?.currency
	});

	const items = t('pricing.faq.items', {
		returnObjects: true,
		trialDays: TRIAL_DAYS,
		bestPrice,
		trialPrice,
		imageTtlHours: IMAGE_TTL_HOURS
	});

	return (
		<Box component="section" pb={[4, 8]} pt={[1, 3.75]}>
			<Container
				maxWidth="false"
				sx={{
					maxWidth: '992px',
					padding: 0
				}}
			>
				<Box>
					{items.map((item, index) => (
						<Accordion
							key={index}
							sx={{
								'&:last-child': {
									borderBottom: '1px solid #E8E8E8'
								},
								margin: '0 0'
							}}
							defaultExpanded={index === 0}
						>
							<AccordionSummary
								sx={{
									'.MuiAccordionSummary-content': {
										my: ['21px', '30px']
									}
								}}
							>
								{item.question}
							</AccordionSummary>
							<AccordionDetails
								color="text.secondary"
								sx={{
									pt: ['1px', '12px'],
									pb: ['22px', '31px'],
									whiteSpace: 'pre-line'
								}}
							>
								<Trans
									defaults={item.answer}
									components={{ strong: <strong /> }}
								/>
							</AccordionDetails>
						</Accordion>
					))}
				</Box>
			</Container>
		</Box>
	);
}
